var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { attrs: { "md-flex": "90", "md-flex-offset": "5" } },
        [
          _c(
            "md-card",
            { staticClass: "md-table-card content-table" },
            [
              _c(
                "form",
                {
                  staticClass: "search-form",
                  attrs: { novalidate: "novalidate" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.resetPaginationAndSearch.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-gutter": 24, "md-flex": "100" } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "100" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Metric")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: {
                                    selected: _vm.resetPaginationAndSearch
                                  },
                                  model: {
                                    value: _vm.filters.e,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "e", $$v)
                                    },
                                    expression: "filters.e"
                                  }
                                },
                                [
                                  _c(
                                    "md-option",
                                    { attrs: { value: "feedloaded" } },
                                    [_vm._v("Feeds Loaded")]
                                  ),
                                  _c(
                                    "md-option",
                                    { attrs: { value: "contentStart" } },
                                    [_vm._v("Content Starts")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "28",
                            "md-flex-small": "40",
                            "md-flex-xsmall": "50"
                          }
                        },
                        [
                          _c("date-input", {
                            attrs: {
                              validation: _vm.$v.filters.startdate,
                              formSubmitted: true,
                              label: "From date"
                            },
                            model: {
                              value: _vm.filters.startdate,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "startdate", $$v)
                              },
                              expression: "filters.startdate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "28",
                            "md-flex-small": "40",
                            "md-flex-xsmall": "50"
                          }
                        },
                        [
                          _c("date-input", {
                            attrs: {
                              validation: _vm.$v.filters.enddate,
                              formSubmitted: true,
                              label: "To date"
                            },
                            model: {
                              value: _vm.filters.enddate,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "enddate", $$v)
                              },
                              expression: "filters.enddate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "5",
                            "md-flex-small": "20",
                            "md-flex-xsmall": "100",
                            "md-align-xsmall": "center"
                          }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "search-btn md-icon-button btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.loading || _vm.$v.$invalid
                              }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "icon",
                                attrs: { "md-iconset": "fa fa-search" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            id: "total-views",
                            "md-flex": "25",
                            "md-flex-small": "100",
                            "md-align": "end"
                          }
                        },
                        [
                          _c(
                            "transition",
                            {
                              attrs: {
                                name: "bounce",
                                "enter-active-class": "animated bounceIn",
                                "leave-active-class": "animated bounceOut"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.totalViews > 0 && !_vm.loading,
                                      expression: "totalViews > 0 && !loading"
                                    }
                                  ],
                                  staticClass: "md-subheading",
                                  attrs: { id: "totalViews" }
                                },
                                [
                                  _vm._v(
                                    "Total views: " +
                                      _vm._s(_vm.formattedTotalViews)
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "70", "md-flex-small": "100" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "filter-link md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.getFrom("today")
                                }
                              }
                            },
                            [_vm._v("Today")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "filter-link md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.getFrom("yesterday")
                                }
                              }
                            },
                            [_vm._v("Yesterday")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "filter-link md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.getFrom("last_week")
                                }
                              }
                            },
                            [_vm._v("Last 7 days")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "filter-link md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.getFrom("this_month")
                                }
                              }
                            },
                            [_vm._v("This month")]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "filter-link md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.getFrom("last_month")
                                }
                              }
                            },
                            [_vm._v("Last month")]
                          )
                        ]
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "30",
                            "md-flex-small": "100",
                            "md-align": "end"
                          }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary md-raised md-dense",
                              attrs: {
                                "md-theme": "rhebus-blue",
                                disabled: _vm.loading || _vm.$v.$invalid
                              },
                              on: { click: _vm.exportCSV }
                            },
                            [_vm._v("Export CSV")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loading, size: 45 } },
                [
                  _vm.logs.length > 0
                    ? _c(
                        "div",
                        { staticClass: "table" },
                        [
                          _c("div", { staticClass: "titleLine styleRow" }, [
                            _c(
                              "p",
                              {
                                staticClass: "rowElements sortable",
                                on: {
                                  click: function($event) {
                                    return _vm.onSort("date")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Date " +
                                    _vm._s(
                                      _vm.sort.name === "date"
                                        ? _vm.sort.type === "desc"
                                          ? "↓"
                                          : "↑"
                                        : ""
                                    )
                                )
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticClass: "rowElements sortable",
                                on: {
                                  click: function($event) {
                                    return _vm.onSort("distribution.name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Distribution " +
                                    _vm._s(
                                      _vm.sort.name === "distribution.name"
                                        ? _vm.sort.type === "desc"
                                          ? "↓"
                                          : "↑"
                                        : ""
                                    )
                                )
                              ]
                            ),
                            _vm.filters.e === "timeupdate"
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "rowElements sortable",
                                    on: {
                                      click: function($event) {
                                        return _vm.onSort("content.name")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Distribution " +
                                        _vm._s(
                                          _vm.sort.name === "content.name"
                                            ? _vm.sort.type === "desc"
                                              ? "↓"
                                              : "↑"
                                            : ""
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "p",
                              {
                                staticClass: "rowElements sortable",
                                on: {
                                  click: function($event) {
                                    return _vm.onSort("geo")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Distribution " +
                                    _vm._s(
                                      _vm.sort.name === "geo"
                                        ? _vm.sort.type === "desc"
                                          ? "↓"
                                          : "↑"
                                        : ""
                                    )
                                )
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticClass: "rowElements sortable",
                                on: {
                                  click: function($event) {
                                    return _vm.onSort("platform")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Platform " +
                                    _vm._s(
                                      _vm.sort.name === "platform"
                                        ? _vm.sort.type === "desc"
                                          ? "↓"
                                          : "↑"
                                        : ""
                                    )
                                )
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticClass: "rowElements sortable",
                                on: {
                                  click: function($event) {
                                    return _vm.onSort("views")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Views " +
                                    _vm._s(
                                      _vm.sort.name === "views"
                                        ? _vm.sort.type === "desc"
                                          ? "↓"
                                          : "↑"
                                        : ""
                                    )
                                )
                              ]
                            )
                          ]),
                          _vm._l(_vm.logs, function(log) {
                            return _c(
                              "div",
                              {
                                key: log._id,
                                staticClass: "styleRow colorHover"
                              },
                              [
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(log.date))
                                ]),
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(log.distribution))
                                ]),
                                _vm.filters.e === "timeupdate"
                                  ? _c("div", { staticClass: "rowElements" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            log.mediaItem ? log.mediaItem : "-"
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(log.country))
                                ]),
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(log.platform))
                                ]),
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(log.views))
                                ])
                              ]
                            )
                          }),
                          _c("md-table-pagination", {
                            attrs: {
                              "md-size": _vm.currentPagination.size,
                              "md-total": _vm.totalLogs,
                              "md-page": _vm.currentPagination.page,
                              "md-label": "Logs",
                              "md-separator": "of",
                              "md-page-options": [10, 25, 50, 100]
                            },
                            on: { pagination: _vm.onPageChanged }
                          })
                        ],
                        2
                      )
                    : _c("md-layout", { attrs: { "md-align": "center" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "md-subheading",
                            attrs: { id: "no-results" }
                          },
                          [
                            _c("md-icon", {
                              staticClass: "md-accent",
                              attrs: {
                                "md-iconset": "fa fa-exclamation-circle"
                              }
                            }),
                            _vm._v("No items to show")
                          ],
                          1
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aac407ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aac407ee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/report/ReportTable.vue
// module id = 1010
// module chunks = 0